/* eslint-disable tailwindcss/no-arbitrary-value */
import classNames from 'classnames';
import { PropsWithChildren } from 'react';

export const TheWrapper: React.FC<IPropsWrapper> = ({
  background,
  type,
  extraClass,
  customFull,
  titleCentered,
  children,
  id,
  title,
}) => {
  const sectionClasses = classNames(
    // 'p-4 pt-0 xl:p-10 xl:pt-0',
    {
      'bg-blue-light sm:py-4 xl:py-10': background === 'blue',
      'bg-green-light': background === 'bg-green-light-variant',
    },
    extraClass,
  );

  const titleClasses = classNames({
    'alpha-display-1': ['simple', 'full'].includes(type),
    'alpha-subheading-1': type === 'default',
    'mb-4': type === 'simple',
    'sm:text-center': titleCentered,
  });

  const subsectionClasses = classNames(
    { 'mx-auto max-w-screen-2xl px-0': !customFull },
    { 'bg-white shadow rounded-2xl xl:rounded-3xl': type === 'default' },
    customFull,
  );

  const wrapperTitleClasses = classNames({
    'mhg-alpha-spacing-padding-y-spacing-padding-x py-4': type === 'default',
  });

  return (
    <section id={id} className={sectionClasses}>
      <div className={subsectionClasses}>
        {title && (
          <div className={wrapperTitleClasses}>
            <h3 className={titleClasses}>{title}</h3>
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

/**
 * type - style for different section from VUE-component. Set style from title, subsection block and common-style section.
 * background - only two value from WinterCMS: 'blue' and 'bg-green-light-variant'
 * customFull - custom subseccion tailwind-classes
 * extraClass - custom section tailwind-classes
 */
export interface IPropsWrapper
  extends PropsWithChildren<{
    id?: string;
    title?: string;
    type: 'simple' | 'full' | 'default';
    titleCentered?: boolean;
    background?: 'blue' | 'bg-green-light-variant';
    customFull?: string;
    extraClass?: string;
  }> {}
